import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

function RolesTable({ setshowdetailsroletable, setrole, refresh, setrefresh }) {
  const [rolesData, setRolesData] = useState([]);
  const [loading, setloading] = useState(false);
  const nav = useNavigate();
  const [deleteLoader, setDeleteLoader] = useState([]);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/Roles/GetAllRoles`)
      .then((res) => {
        setRolesData(res?.data);
        setDeleteLoader(Array.from({ length: res?.data?.length }, () => false));
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [refresh]);

  return (
    <section className="table">
      <section>
        <div>
          <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
            <blockquote>Sr.No.</blockquote>
            <blockquote>Role Name</blockquote>
            <blockquote>Permissions</blockquote>
            <blockquote></blockquote>
          </aside>
        </div>
        <div>
          {loading ? (
            <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
              <blockquote style={{ gridColumn: "span 4" }}>
                <center>
                  <i
                    className="fa-solid fa-rotate-right fa-spin"
                    style={{ fontSize: "2.5rem" }}
                  ></i>
                </center>
              </blockquote>
            </aside>
          ) : rolesData.length > 0 ? (
            rolesData
              .filter((x) => x.roleName !== "Administrator")
              .map((role, idx) => (
                <aside
                  key={idx}
                  style={{ gridTemplateColumns: "repeat(4, 1fr)" }}
                >
                  <blockquote>{idx + 1}</blockquote>
                  <blockquote>{role.roleName}</blockquote>
                  <blockquote>
                    <a
                      href="#"
                      onClick={() => {
                        setshowdetailsroletable(true);
                        setrole(role.roleName);
                      }}
                    >
                      Click to See More
                    </a>
                  </blockquote>
                  <blockquote
                    onClick={() => {
                      Swal.fire({
                        icon: "error",
                        title: "Are You Sure?",
                        text: "This Role AlongWith Permissions Will get Deleted",
                        showConfirmButton: true,
                        showCancelButton: true,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          setDeleteLoader((prev) =>
                            prev.map((_, i) => i === idx)
                          );
                          axiosInstance
                            .delete(
                              `${process.env.REACT_APP_API_URL}/api/Roles/DeleteRole?roleName=${role.roleName}`
                            )
                            .then((res) => {
                              toast.success(res.data, {
                                position: "bottom-center",
                                theme: "dark",
                              });
                              setrefresh(!refresh);
                            })
                            .catch((err) => {
                              Swal.fire({
                                icon: "info",
                                text: err.response.data,
                              });
                            })
                            .finally(() => {
                              setDeleteLoader((prev) => prev.map((_) => false));
                            });
                        }
                      });
                    }}
                  >
                    {deleteLoader[idx] ? (
                      <i className="fa-solid fa-spinner fa-spin"></i>
                    ) : (
                      <i className="fa-solid fa-trash"></i>
                    )}
                  </blockquote>
                </aside>
              ))
          ) : (
            <aside style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
              <blockquote style={{ gridColumn: "span 4" }}>
                <center>No Records Found</center>
              </blockquote>
            </aside>
          )}
        </div>
      </section>
    </section>
  );
}

export default RolesTable;
